import React from 'react'
import './Footer.scss'

const Footer = () => {
  return (
    <footer>
      Made with ❤️ by <b>Juan Helbert</b>
    </footer>
  )
}

export { Footer }